import InvestWithdrawlForm from './InvestWithdrawlForm';

export default InvestWithdrawlForm;
